import DataStoreRequestBase from "./DataStoreRequestBase/DataStoreRequestBase";

const DataStoreRequest = () => {
  return (
    <>
    <DataStoreRequestBase />
    </>
  );
};

export default DataStoreRequest;
